import React, {useState} from 'react';
import {Checkbox} from "@mui/material";
import HeaderService from "../../../../../../API/orders/orders/organization/HeaderService";

const CellCheckboxMHTUnableModels = ({cell, id, change, setChange, disabled, handleModalAlert}) => {

    const [status, setStatus] = useState(cell.getValue);
    const handle = () => {
        HeaderService.unableForModels(id, !status)
            .then(function () {
                setStatus(!status)
                setChange(!change)
                handleModalAlert("Данные изменены", 'success')
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
    }

    return (
        <div>
            <Checkbox onChange={handle}
                      checked={status}
                      disabled={disabled}
                      sx={{'& .MuiSvgIcon-root': {fontSize: 20}}}
            />
        </div>
    );
};

export default CellCheckboxMHTUnableModels;